import React, { Component } from "react";
import t from "tcomb-form";
import { Link } from "react-router-dom";
import "./SignUp.css";
import { Container, Button, Row, Col, Card, Image } from "react-bootstrap";
import myCustomTemplate from "../Common/customTemplate";
import Navbar from "../../components/Navbar/Navbar";
export interface Props {
  signups: any;
}

export interface State {}

var checkpassword = null;

const fnameField = t.refinement(t.String, value => {
  //const reg = new RegExp("^[a-zA-Z]+$");
  const reg = /[a-zA-Z]+(\s[a-zA-Z]+)?$/;

  return reg.test(value);
});

const lnameField = t.refinement(t.String, value => {
  //const reg = new RegExp("[A-Za-z])+( [A-Za-z]+");//^[a-z A-Z]+$
  const reg = /[a-zA-Z]+(\s[a-zA-Z]+)?$/;
  return reg.test(value);
});
const emailField = t.refinement(t.String, value => {
  const reg = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return reg.test(value);
});

const mobField = t.refinement(t.Number, value => {
  return JSON.stringify(value).length === 10;
});

const pswdField = t.refinement(t.String, value => {
  checkpassword = value;
  return value.length >= 6;
});

const cnfrmPswdField = t.refinement(t.String, value => {
  return value === checkpassword;
});

const Form = t.form.Form;
const signUpFormStruct = t.struct({
  fname: fnameField,
  lname: lnameField,
  email: emailField,
  mobileNo: mobField,
  password: pswdField,
  Cpassword: cnfrmPswdField
});

const options = {
  fields: {
    fname: {
      template: myCustomTemplate,

      config: {
        placeholder: "First Name",
        errorMessage: "Required field. Please enter a valid input",

        // label: "First Name",
        type: "text"
      }
    },
    lname: {
      template: myCustomTemplate,

      config: {
        placeholder: "Last Name",
        errorMessage: "Required field. Please enter a valid input",

        // label: "Last Name",
        type: "text"
      }
    },
    email: {
      template: myCustomTemplate,

      config: {
        placeholder: "Email",
        errorMessage: "Required field. Please enter a valid email",

        // label: "Email",
        type: "text"
      }
    },
    mobileNo: {
      template: myCustomTemplate,

      config: {
        placeholder: "Mobile number",
        errorMessage: "Required field. Please enter a valid mobile number",

        // label: "Mobile Number",
        type: "text"
      }
    },
    password: {
      template: myCustomTemplate,

      config: {
        placeholder: "Password",
        // label: "Password",
        errorMessage: "Required field. Password should be 6 characters long",
        type: "password"
      }
    },
    Cpassword: {
      template: myCustomTemplate,

      config: {
        placeholder: "Confirm password",
        // label: "Confirm Password",
        errorMessage: "Required field. Passwords should match",
        type: "password"
      }
    }
  }
};

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: options,
      value: {
        fname: "",
        lname: "",
        email: "",
        mobileNo: "",
        password: "",
        Cpassword: ""
      }
    };
    this.onChange = this.onChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.props.fetchtandc();
  }

  onChange(Person1, path) {
    console.log("*************************", Person1, path);
    this.refs.form.getComponent(path).validate();
    // this.setState({ value: Person1 });
  }

  submit(event) {
    var value = this.refs.form.getValue();
    console.log("======================", value);
    if (value) {
      let data = {
        value: {
          fname: value.fname,
          lname: value.lname,
          email: value.email,
          password: value.password,
          Cpassword: value.Cpassword,
          mobileNo: value.mobileNo
        }
      };
      this.props.signup(data);
    }
  }
  render() {
    const terms = this.props.tnc && this.props.tnc;
    return (
      <div>
        <Navbar></Navbar>
        <div className="bgcolorLogin container-fluid">
          <div>
            <div>
              <Container>
                <div className="cardMainsignup">
                  <Row>
                    <Col xs={12} md={6} sm={12} lg={6}>
                      <div>
                        <img
                          className="signupimage"
                          src={require("../../assets/img/hero-img (2).png")}
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={1} sm={12} lg={1}></Col>
                    <Col xs={12} md={4} sm={12} lg={4}>
                      <div className="loginheaderfrst">
                        <div>
                          <h3 className="signupheader">Sign Up</h3>
                          <div className="loginundelne"></div>
                        </div>
                        <Link to="/login" className="signupanaccount">
                          Already have an account?
                          <span className="accountsignup"> Login</span>
                        </Link>
                        <div className="signupform">
                          <Form
                            ref="form"
                            type={signUpFormStruct}
                            options={this.state.options}
                            value={this.state.value}
                            onChange={(v, path) => this.onChange(v, path)}
                          />

                          <div className="forgotsignPswddiv">
                            <p className="signupagree">
                              By submitting, you agree to{" "}
                              <a
                                href={`https://www.quikpharma.com/termsConditions.html`}
                                target="_blank"
                              >
                                Terms & Conditions
                              </a>{" "}
                              and{" "}
                              <a
                                href={`${terms &&
                                  terms[0].privacyUrl &&
                                  terms[0].privacyUrl}`}
                                target="_blank"
                              >
                                {" "}
                                Privacy Policy
                              </a>
                            </p>
                          </div>
                          <Button
                            className="signuppagebtn"
                            size="lg"
                            onClick={this.submit}
                          >
                            Sign Up
                          </Button>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={1} sm={12} lg={1}></Col>
                  </Row>
                </div>
              </Container>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SignUp;
